import { ArchiveItem } from "models/ArchiveItem";
import { NODE_TYPE_ROOT } from "../../views/documents/state/documentArchiveOptions";

export type ArchiveState = {
  isMovingFile: boolean;
  isUploading: boolean;
  isLoadingFolder: boolean;
  isLoadingArchiveRoot: boolean;
  archiveRoot: ArchiveItem[];
  selectedFolderId: string;
  selectedFolderFiles: ArchiveItem[];
};

export const initialArchiveState: ArchiveState = {
  isMovingFile: false,
  isUploading: false,
  isLoadingFolder: false,
  isLoadingArchiveRoot: false,
  selectedFolderId: NODE_TYPE_ROOT,
  archiveRoot: [],
  selectedFolderFiles: []
};
